import React from "react";

const TermsConditions = () => {
  return (
    <div className="bg-gray-200 min-h-screen py-10">
      <div className="container mx-auto px-4 md:px-8">
        <h1 className="text-3xl font-bold  text-center text-[#0069a7] mb-8">
          अटी व शर्ती
        </h1>
        <div className="bg-white font-md  shadow-md rounded-lg p-6 md:p-10 space-y-6 transition-transform duration-500 ">
          <p className="text-gray-700 leading-relaxed">
            १. आमच्या वधू वर सूचक केंद्रात सर्व जाती धर्मांचे विवाह इच्छुक वधू वरांची नाव नोंदणी होते.
          </p>
          <p className="text-gray-700 leading-relaxed">
            २. नाव नोंदणीनंतर स्थानिक प्रोफाइल वेबसाईटवर अपलोड केला जातो आणि आपल्यास वेबसाईटचा एक आयडी दिला जातो.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ३. रु. 3500 सहामाही फी, रु. 4500 वार्षिक फी.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ४. आपल्यास जुळवण असल्यास स्थानिक माहिती मेसेज द्वारे आपल्यास दिली जाते.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ५. नाव नोंदणी करणाऱ्यांनी आपल्या स्थळाची माहिती खरी द्यावी, ही त्याची नैतिक व कायदेशीर जबाबदारी आहे, यात काही असत्य असल्यास त्याची सर्व कायदेशीर जबाबदारी नाव नोंदणी करणाऱ्यावर राहील.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ६. सभासदांन पस्त असल्यास स्थळाशी संपर्क स्वतः करावा, व स्थळाच्या माहितिची खातरजमा करूनच पुढील आयुष्याचा निर्णय घ्यावा.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ७. संस्थेतील किंवा स्वतःच्या प्रयत्नाने जुळून आल्यास त्या संबंधिताची माहिती विनासंबंध नजीकच्या शाखेस कळवावी.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ८. नाव नोंदणी नंतर विवाह जुळेलच किंवा अमुक दिवसात जुळेल, याची हमी आम्ही देत नाही.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ९. वधू वर केंद्रातील माहितिचा अगर फोटोचा कोणीही गैरवापर करू नये, केल्यास त्याचे सभासदत्व कोणतीही पूर्वसूचना न देता रद्द केली जाईल.
          </p>
          <p className="text-gray-700 leading-relaxed">
            १०. विवाह जुळल्यानंतर भविष्यात काही प्रश्न उपस्थित झाल्यास संस्था, संस्थेची कोणतीही शाखा अगर संचालक जबाबदार राहणार नाही.
          </p>
          <p className="text-gray-700 leading-relaxed">
            ११. नाव नोंदणी नंतर सभासदाने कोणत्याही शाखेशी अगर हेड ऑफिसशी माझे पुढे काय झाले, म्हणून सतत फोन करून त्रास देऊ नये, कारण तुमच्या इतकेच इतर ही सभासद संस्थेचे तितकेच महत्वाचे आहेत. तुम्हाला आम्ही नवीन स्थळाबद्दल माहिती अपडेट करत राहू.
          </p>
          <p className="text-gray-700 leading-relaxed">
            १२. वरील प्रमाणे सर्व अटी मान्य असणाऱ्यांनीच नाव नोंद करावे. कोणत्याही सर्वभिव एकदा भरलेली फी परत मिळणार नाही.
          </p>
          <p className="text-gray-700 leading-relaxed">
            १३. तुमची नोंदणी झाल्यानंतर तुम्हाला ऑटोमॅटिक ग्राहक क्रमांक आणि पासवर्ड मिळेल, युझर लॉगिन मध्ये जाऊन तुमचा आयडी क्रमांक आणि ओळख पासवर्ड टाकून तुमच्या जातीचे आणि तुम्हाला चालत असेल तर आंतरजातीचे स्थळे पाहू शहण पाहू शकता.
          </p>
          {/* <h2 className="text-gray-800 font-bold text-lg">आमचे प्लान्स</h2> */}
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
